import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { roomCreate, roomJoin, clearError } from "../../../../redux/actions/roomAction";
import { tokenValidation } from "../../../../redux/actions/userAction";

const RoomRegister = props => {
	const roomDuty = props.roomDuty; // "join_chat" || "create_chat"
	const isRoomJoin = roomDuty.search("join") != -1 ? true : false;

	const dispatch = useDispatch();
	const history = useHistory();
	const userState = useSelector(state => state.user); // { isLoading, validToken, id, username, email, err }
	const roomState = useSelector(state => state.room); // { isLoading, _id, roomName, messages: { [ _id, username, message ] }, err: "Missing field" || "Room already exist" ||  "Room doesn't exist" || "Invalid password"

	const [roomInfo, setRoomInfo] = useState({ roomName: "", password: "" });
	const [errorMessage, setErrorMessage] = useState("");
	const [isErrorMessageVisible, setIsErrorMessageVisible] = useState(false);

	useEffect(() => {
		if (roomState.err) dispatch(clearError());
	}, []);

	useEffect(() => {
		if (roomState.err) {
			switch (roomState.err) {
				case "Missing field":
					setErrorMessage(`Warning: ${roomState.err}`);
					setIsErrorMessageVisible(true);
					break;

				case "Room already exist": // Error for room create
				case "Room doesn't exist": // Error for room join
					setRoomInfo({ roomName: "", password: "" });
					setErrorMessage(`Invalid input: ${roomState.err}`);
					setIsErrorMessageVisible(true);
					break;

				case "Invalid password": // Error for room join
					setRoomInfo({ roomName: roomInfo.roomName, password: "" });
					setErrorMessage(`Invalid input: ${roomState.err}`);
					setIsErrorMessageVisible(true);
					break;
				case "":
					setIsErrorMessageVisible(false);
					break;
			}
		}
	}, [roomState.err]);

	const [registerBtnClick, setRegisterBtnClicked] = useState(false); // Indicates whether register button is clicked or not
	// After Receiving the token verification, redirect to login if token is invalid and if valid dispatch roomJoin
	useEffect(() => {
		if (!userState.isLoading && registerBtnClick) {
			if (userState.validToken) {
				if (isRoomJoin) dispatch(roomJoin(roomInfo.roomName, roomInfo.password));
				else dispatch(roomCreate(roomInfo.roomName, roomInfo.password));
				setRegisterBtnClicked(false);
			} else history.push("/login");
		}
	}, [userState]);

	// Wait for the chat data to load before proceeding to chatbox page
	useEffect(() => {
		if (roomState._id) history.push(`/board/${roomState._id}`);
	}, [roomState._id]);

	return (
		<React.Fragment>
			<h1 className="board-title title">Board:</h1>
			<input
				type="text"
				name="roomName"
				placeholder="Board Name"
				className={roomInfo.roomName ? "board-input input-highlight" : "board-input"}
				value={roomInfo.roomName}
				onChange={e => {
					setRoomInfo({ ...roomInfo, [e.target.name]: e.target.value });
					if (errorMessage) {
						// setErrorMessage("");
						setIsErrorMessageVisible(false);
						dispatch(clearError());
					}
				}}
			/>
			<h1 className="password-title title">Password:</h1>

			<input
				type="password"
				name="password"
				placeholder="Password"
				className={roomInfo.password ? "password-input input-highlight" : "password-input"}
				value={roomInfo.password}
				onChange={e => {
					setRoomInfo({ ...roomInfo, [e.target.name]: e.target.value });
					if (errorMessage) {
						// setErrorMessage("");
						setIsErrorMessageVisible(false);
						dispatch(clearError());
					}
				}}
			/>

			<input
				type="submit"
				value={isRoomJoin ? "JOIN" : "CREATE"}
				className="board-submit"
				onSubmit={() => console.log("submit alert!!!!")}
				onClick={() => {
					// dispatch(tokenValidation(localStorage.getItem("auth-token"))); // validate the token
					dispatch(tokenValidation()); // validating the token
					setRegisterBtnClicked(true);
				}}
			/>
			<span className={isErrorMessageVisible ? "warning-enable error-msg" : "warning-disable error-msg"}>{errorMessage}</span>
		</React.Fragment>
	);
};

export default RoomRegister;
